import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useWithdrawStore = defineStore("withdraw", {
    state: () => {
        return {
            availbles: 0,
            alls: 0,
            lists: [],
            totals: 0,
            networks: [],
            selectedNetworks: null,
            selectedCoin: null,
            coin: [],
            loadings: false
        };
    },

    getters: {
        network: (state) => state.networks,
        list: (state) => state.lists,
        selectedNetwork: (state) => state.selectedNetworks,
        selectedCoins: (state) => state.selectedCoin,
        all: (state) => state.alls,
        total: (state) => state.totals,
        availble: (state) => state.availbles,
        coins: (state) => state.coin,
        loading: (state) => state.loadings
    },

    actions: {
        get(filters) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'profile/withdraw/availble',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...filters
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.availbles = res.data.data.availble
                        this.alls = res.data.data.all
                        this.networks = res.data.data.network
                        this.selectedNetworks = res.data.data.network[0]
                        this.coin = res.data.data.coins
                        this.selectedCoin = res.data.data.coins[0]
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        history(filters) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'profile/withdraw/list',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...filters
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.lists = res.data.data.lst
                        this.totals = res?.data?.data?.count
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        post(obj) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'profile/withdraw/balance',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...obj
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        }
    },
});